// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"6a7170f5","151":"0eacc1dc","247":"6eeac184","844":"6a7170f5","853":"6a7170f5","933":"0da08017"}[chunkId] + ".css";
};